import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const FAVICON_VERSION = "20260802";

const refreshFavicon = () => {
  const stamp = `?v=${FAVICON_VERSION}`;
  document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]').forEach((node) => {
    node.remove();
  });
  const png = document.createElement("link");
  png.rel = "icon";
  png.type = "image/png";
  png.href = `/favicon.png${stamp}`;
  document.head.appendChild(png);

  const ico = document.createElement("link");
  ico.rel = "shortcut icon";
  ico.href = `/favicon.ico${stamp}`;
  document.head.appendChild(ico);

  const apple = document.createElement("link");
  apple.rel = "apple-touch-icon";
  apple.href = `/favicon.png${stamp}`;
  document.head.appendChild(apple);
};

refreshFavicon();

const removeEmergentBadge = () => {
  document
    .querySelectorAll('#emergent-badge, a[href*="emergent-badge"], a[href*="app.emergent.sh"]')
    .forEach((node) => node.remove());
};

if (process.env.NODE_ENV !== "production") {
  removeEmergentBadge();
  new MutationObserver(removeEmergentBadge).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
